module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideShowArea),
      expression: "!hideShowArea"
    }]
  }, [_vm._v("下单宝贝")]), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": '选择' + _vm.textTitle + '宝贝类型'
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeBabyType
    },
    model: {
      value: (_vm.form.BabyType),
      callback: function($$v) {
        _vm.$set(_vm.form, "BabyType", $$v)
      },
      expression: "form.BabyType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("正式合作园宝贝")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("非正式合作园宝贝")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.BabyType === 0),
      expression: "form.BabyType===0"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属园所"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": ""
    },
    on: {
      "focus": _vm.chooseSchool
    },
    model: {
      value: (_vm.info.SchoolName),
      callback: function($$v) {
        _vm.$set(_vm.info, "SchoolName", $$v)
      },
      expression: "info.SchoolName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属班级"
    }
  }, [(_vm.info.SchoolName == '非正式合作园所') ? _c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": "",
      "value": "非正式合作班级"
    }
  }) : _c('el-select', {
    staticClass: "formlength",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.info.ClassId),
      callback: function($$v) {
        _vm.$set(_vm.info, "ClassId", $$v)
      },
      expression: "info.ClassId"
    }
  }, _vm._l((_vm.classList), function(item) {
    return _c('el-option', {
      key: item.ClassId,
      attrs: {
        "label": item.ClassName,
        "value": item.ClassId
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.info.AgentName))])])], 1)], 1), _vm._v(" "), (!_vm.isReadOnly) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": '请选择' + _vm.textTitle + '宝贝'
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseBaby
    }
  }, [_vm._v("选择" + _vm._s(_vm.textTitle) + "宝贝")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.babyName !== ''),
      expression: "info.babyName!==''"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "宝贝姓名："
    }
  }, [_vm._v("\n            " + _vm._s(_vm.info.babyName) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别："
    }
  }, [_vm._v("\n            " + _vm._s(_vm.info.babySex) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出生年月日："
    }
  }, [_vm._v("\n            " + _vm._s(_vm.info.babyDath) + "\n          ")])], 1)], 1), _vm._v(" "), (!_vm.isReadOnly) ? _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideShowArea),
      expression: "!hideShowArea"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": '选择' + _vm.textTitle + '家长'
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseParent
    }
  }, [_vm._v("选择" + _vm._s(_vm.textTitle) + "家长")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.parentName !== '' || _vm.info.parentTel !== ''),
      expression: "info.parentName!==''||info.parentTel!==''"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "家长姓名："
    }
  }, [_vm._v("\n            " + _vm._s(_vm.info.parentName) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "家长电话："
    }
  }, [_vm._v("\n            " + _vm._s(_vm.info.parentTel) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "与宝贝的家庭关系："
    }
  }, [_vm._v("\n            " + _vm._s(_vm.info.parentNick) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideShowArea),
      expression: "!hideShowArea"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.packageId == 10002),
      expression: "packageId==10002"
    }]
  }, [_c('h4', [_vm._v("网络情况")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "家庭网络运营商："
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.NetInfo.NetworkOperator),
      callback: function($$v) {
        _vm.$set(_vm.form.NetInfo, "NetworkOperator", $$v)
      },
      expression: "form.NetInfo.NetworkOperator"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("移动")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("电信")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("联通")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 8
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "家庭网络情况："
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.NetInfo.NetworkType),
      callback: function($$v) {
        _vm.$set(_vm.form.NetInfo, "NetworkType", $$v)
      },
      expression: "form.NetInfo.NetworkType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("有线")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("无线")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowD),
      expression: "isShowD"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "电视到宽带口距离多远："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.NetInfo.Distance),
      callback: function($$v) {
        _vm.$set(_vm.form.NetInfo, "Distance", $$v)
      },
      expression: "form.NetInfo.Distance"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("10米")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("30米")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("50米")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 8
    }
  }, [_vm._v("100米以上")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否需要上门服务："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.NetInfo.Engineer),
      callback: function($$v) {
        _vm.$set(_vm.form.NetInfo, "Engineer", $$v)
      },
      expression: "form.NetInfo.Engineer"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("需要工程师上门")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("不需要,自己解决网络")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("收货信息\n          "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeAddress
    }
  }, [_vm._v("选择地址")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人:"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ConsigneeData.Consignee) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人电话:"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ConsigneeData.ConsigneeTel) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "details-addr",
    attrs: {
      "label": "收货地址:"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ConsigneeData.ConsigneeArea) + _vm._s(_vm.ConsigneeData.ConsigneeAdress) + "\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("支付信息")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择支付金额"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.DiscountType),
      callback: function($$v) {
        _vm.$set(_vm.form, "DiscountType", $$v)
      },
      expression: "form.DiscountType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("家长订购价")]), _vm._v(" "), _c('el-radio-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.packageId == 10003),
      expression: "packageId==10003"
    }],
    attrs: {
      "label": 10
    }
  }, [_vm._v("内部订购价")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单金额"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.price))]), _vm._v(" 元\n          ")])], 1), _vm._v(" "), _vm._l((_vm.payList), function(item, index) {
    return _c('payTypeInfo', {
      key: index + 1,
      ref: 'payInfo' + (index + 1),
      refInFor: true,
      staticStyle: {
        "margin-left": "-50px"
      },
      attrs: {
        "myIndex": (index + 1),
        "value": item,
        "isLBHome": true,
        "hasDelFn": _vm.isDelShow[index]
      },
      on: {
        "delPayfn": _vm.delPayFn
      }
    })
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addFn
    }
  }, [_vm._v("新增支付方式")])], 1)], 2)]), _vm._v(" "), _c('schoolList', {
    ref: "schoolList",
    on: {
      "dialogList": _vm.getDialogList
    }
  }), _vm._v(" "), _c('babyDialog', {
    ref: "babyDialog",
    on: {
      "babyInfo": _vm.getBabyInfo
    }
  }), _vm._v(" "), _c('parentDialog', {
    ref: "parentDialog",
    on: {
      "parentInfo": _vm.getParentInfo
    }
  }), _vm._v(" "), _c('AddressDialog', {
    ref: "AddressDialog",
    on: {
      "address": _vm.getAddress,
      "getSchoolConsigneeList": _vm.GetBabyConsigneeList
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51963739!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/LBHomeOrder/components/orderDetails/index.vue
// module id = 1478
// module chunks = 1